module.exports = __webpack_public_path__ + "img/logo.d6e25108.png";